import React from "react";
import RefinementList from "components/search/base/RefinementList";
import timePeriodCategories from "components/search/references/timePeriodCategories";

const TimePeriodRefinementList = () => {
  return (
    <RefinementList
      attribute="timePeriod"
      categories={timePeriodCategories}
      limit={100}
      refinementLimit={3}
      title="Time Period (When Written)"
    />
  );
};

export default TimePeriodRefinementList;
